// Author Lin
// Date 2021-11-27 11:07:09

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingElectrodeWeightChangeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingElectrodeWeightChange(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
